import { connect } from 'react-redux';

import {
  getFunnelExecutionResult,
  getFunnelView,
  getSelectedFunnel,
} from '../../../reducers/analyticsApp';
import { changeFunnelView } from '../../../actions/funnel';
import FunnelExecutionDetails from '../../../components/funnel/execution/Details';

const mapStateToProps = (state) => {
  const result = getFunnelExecutionResult(state);
  const funnel = getSelectedFunnel(state);

  return {
    view: getFunnelView(state),
    chart: (result || {}).chart,
    steps: funnel.steps,
    perStepClosingRangeEnabled: true,
    ...(result && { stepCounters: result.steps }),
  };
};

const mapDispatchToProps = {
  onChangeView: changeFunnelView,
};

export default connect(mapStateToProps, mapDispatchToProps)(FunnelExecutionDetails);
